import {
  Routes as RouterRoutes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import AppLayout from "./layouts/AppLayout";
import Home from "./pages/Home";
import Artworks from "./pages/Artworks";
import ArtworkDetail from "./pages/ArtworkDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
//Admin
import AdminArtworks from "./pages/admin/Artworks"; // aertworks list
import DashboardOverview from "./components/admin/DashboardOverview"; // What's happening
import ProtectedRoute from "./components/ProtectedRoute"; // Check if admin
import AdminLayout from "./components/admin/AdminLayout"; // Page with menu column on left
import ContentManagement from "./pages/admin/ContentManagement"; // User screen text input (about, comntact etc)

// NotFound component
const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        p: 3,
      }}
    >
      <Typography variant="h4" component="h1" gutterBottom>
        Page Not Found
      </Typography>
      <Typography variant="body1" sx={{ mb: 3, textAlign: "center" }}>
        The page you're looking for doesn't exist or may have been moved.
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        <Button variant="contained" onClick={handleGoHome}>
          Go to Home
        </Button>
        <Button variant="outlined" onClick={handleGoBack}>
          Go Back
        </Button>
      </Box>
    </Box>
  );
};

function Routes() {
  const location = useLocation();

  // Debug logging for routing
  console.log("🔗 Current route:", location.pathname);
  console.log("🔗 Full location:", location);
  console.log("🔗 Is admin route:", location.pathname.startsWith("/admin"));
  console.log("🔗 Route matching debug:", {
    pathname: location.pathname,
    isAdmin: location.pathname.startsWith("/admin"),
    exactAdmin: location.pathname === "/admin",
    adminWithSlash: location.pathname === "/admin/",
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      {/* <Box component="main" sx={{ flexGrow: 1, mt: location.pathname.startsWith('/admin') ? 0 : '112px' }}> */}
      <RouterRoutes>
        {/* Public routes */}
        <Route element={<AppLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/artworks" element={<Artworks />} />
          <Route path="/artworks/:id" element={<ArtworkDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/index.html" element={<Home />} />
        </Route>
        {/* Protected routes */}

        {/* Admin routes */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute requireAdmin>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="artworks" element={<AdminArtworks />} />
          <Route path="content" element={<ContentManagement />} />
          <Route index element={<DashboardOverview />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
    </Box>
  );
}

export default Routes;
